var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgUpi = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 19,
  height: 28,
  viewBox: "0 0 19 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M4.92047 27.0142L12.1043 0.650604L18.5568 13.8319L4.92047 27.0142Z",
  fill: "white"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M0.375 27.0142L7.55886 0.650604L14.0114 13.8319L0.375 27.0142Z",
  fill: "white"
})));
export { SvgUpi as ReactComponent };
export default __webpack_public_path__ + "assets/icons/upi.dae65c.svg";